// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__VDz3l","topBottomGutter":"Layout_topBottomGutter__t1pOR"};